module.exports = __webpack_public_path__ + "static/media/Artboard8.f9c90d4d.png";